import React, { useEffect, useRef, useState } from "react";

// icons
import { MicIcon } from "../../../assets/icons/mic-icon";
import { MessageIcon } from "../../../assets/icons/message-icon";
import MiniCallingScreen from "./mini-calling-screen";
import { getInitials } from "../constant/constant";
import { MuteMicIcon } from "../../../assets/icons/mute-mic-icon";
import { MuteMicIconHover } from "../../../assets/icons/mute-mic-icon-hover";
import { MicIconHover } from "../../../assets/icons/mic-icon-hover";
import { MessageIconHover } from "../../../assets/icons/message-icon-hover";

// route
import { useLocation, useNavigate } from "react-router";

// store
import { useDispatch } from "react-redux";
import { setViewData } from "../../../reducer/slices/twilio-calls/view-slice";

const CallingScreen = ({
  callingModal,
  callErrorMsg,
  setCallingModal,
  isMiniScreen,
  setIsMiniScreen,
  isChat,
  setIsChat,
  phoneNumber = "",
  handleHangup,
  trialInfo,
  status,
  setStatus,
  muteCall,
  unMuteCall,
  mute,
  callSid,
  route,
  maximizeCall
}) => {
  const pNameRef = useRef(trialInfo.patientName);
  const pName = pNameRef.current;
  const label = getInitials(pName);
  const [isMaxCallIconHover, setIsMaxCallIconHover] = useState();
  const [isMuteHover, setIsMuteHover] = useState(false);
  const [isRecordingHover, setIsRecordingHover] = useState(false);
  const [isMessageHover, setIsMessageHover] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const onChatClickDesktopView = () => {
    dispatch(
      setViewData({
        isMaxView: true,
        isMinView: true,
      })
    );

    if (location.pathname === route) return;
    navigate(route);
  };

  const onChatClickMinView = () => {
    if (location.pathname === route) return;
    navigate(route);
  };

  return (
    <>
      {!isMiniScreen ? (
        <div className="w-[calc(100%-65px)] h-[calc(100%-76px)] fixed right-0 bottom-0 mx-auto bg-gradient-to-b from-[#eef0fa] to-[#f8f1f7] rounded-xl shadow-xl p-6 z-10">
          {/* Existing inner content remains here */}
          <div
            className="flex flex-col items-center justify-center bg-gradient-to-b from-[#eef0fa] to-[#f8f1f7]"
            style={{ minHeight: "calc(100vh - 80px)" }}
          >
            <div className="flex flex-col items-center space-y-4">
              <div className="w-24 h-24 rounded-full bg-[#f2e4d7] flex items-center justify-center text-3xl font-semibold text-[#c4926c]">
                {label}
              </div>

              <div className="text-center">
                <h2 className="text-xl font-semibold text-[#21293c]">
                  {pName}
                </h2>
                {/* <p className="text-gray-500">{callSid}</p> */}
                {callErrorMsg && (
                  <p className="text-gray-500">{callErrorMsg}</p>
                )}
                <p className="text-gray-500">{status}</p>
              </div>

              <div className="flex space-x-6 mt-6">
                <div className="relative group">
                  {mute ? (
                    <button
                      className="w-12 h-12 rounded-full bg-white flex items-center justify-center shadow-md"
                      onClick={unMuteCall}
                      onMouseEnter={() => {
                        setIsMuteHover(true);
                      }}
                      onMouseLeave={() => {
                        setIsMuteHover(false);
                      }}
                    >
                      {isMuteHover ? <MuteMicIconHover /> : <MuteMicIcon />}
                    </button>
                  ) : (
                    <button
                      className="w-12 h-12 rounded-full bg-white flex items-center justify-center shadow-md"
                      onClick={muteCall}
                      onMouseEnter={() => {
                        setIsMuteHover(true);
                      }}
                      onMouseLeave={() => {
                        setIsMuteHover(false);
                      }}
                    >
                      {isMuteHover ? <MicIconHover /> : <MicIcon />}
                    </button>
                  )}
                  <div className="absolute top-full left-1/2 -translate-x-1/2 mt-1 w-[60px] h-[32px] bg-white text-[#1A1A1B] border border-[#E4E4E4] text-xs flex items-center justify-center rounded z-50 opacity-0 group-hover:opacity-100 transition-opacity duration-200 font-medium">
                    {mute ? "Unmute" : "Mute"}
                  </div>
                </div>

                {/* Recording Button */}
                {/* <div className="relative group">
                <button
                  className="w-12 h-12 rounded-full bg-white flex items-center justify-center shadow-md"
                  onMouseEnter={() => {
                    setIsRecordingHover(true);
                  }}
                  onMouseLeave={() => {
                    setIsRecordingHover(false);
                  }}
                >
                  {isRecordingHover ? (
                    <RecordingIconHover />
                  ) : (
                    <RecordingIcon />
                  )}
                </button>
                <div className="absolute top-full left-1/2 -translate-x-1/2 mt-1 w-[70px] h-[32px] bg-white text-[#1A1A1B] border border-[#E4E4E4] text-xs flex items-center justify-center rounded z-50 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                  Record
                </div>
              </div> */}

                {/* Message Button */}
                <div className="relative group">
                  <button
                    className="w-12 h-12 rounded-full bg-white flex items-center justify-center shadow-md"
                    onClick={onChatClickDesktopView}
                    onMouseEnter={() => {
                      setIsMessageHover(true);
                    }}
                    onMouseLeave={() => {
                      setIsMessageHover(false);
                    }}
                  >
                    {isMessageHover ? <MessageIconHover /> : <MessageIcon />}
                  </button>
                  <div className="absolute top-full left-1/2 -translate-x-1/2 mt-1 w-[150px] h-[32px] bg-white text-[#1A1A1B] border border-[#E4E4E4] text-xs flex items-center justify-center rounded z-50 opacity-0 group-hover:opacity-100 transition-opacity duration-200 font-medium">
                    View Conversation
                  </div>
                </div>
              </div>

              {/* Cancel Call Button */}
              {!["Call ended", "No Answer"].includes(status) && (
                <>
                  {/* <button
                      className="mt-8 px-6 py-2 bg-red-500 text-white rounded-md hover:bg-white hover:text-[#1A1A1B] hover:border hover:border-red-500 transition flex justify-between"
                      onClick={() => {
                        setCallingModal(false);
                        setIsChat(true);
                        handleHangup();
                      }}
                      onMouseEnter={() => {
                        setIsMaxCallIconHover(true);
                      }}
                      onMouseLeave={() => {
                        setIsMaxCallIconHover(false);
                      }}
                    >
                      {["Calling", "Ringing"].includes(status) && (
                        <>
                          {isMaxCallIconHover ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M8.11183 2.97505C7.05974 2.00832 5.44259 2.00832 4.3905 2.97505C4.34741 3.01464 4.30142 3.06065 4.24169 3.12039L3.34419 4.01788C2.44108 4.921 2.06196 6.22292 2.33902 7.4697C3.01964 10.5325 4.44123 13.3048 6.40871 15.5916L2.7807 19.2197C2.48781 19.5126 2.48781 19.9874 2.78071 20.2803C3.0736 20.5732 3.54847 20.5732 3.84137 20.2803L19.8413 4.28033C20.1342 3.98743 20.1342 3.51256 19.8413 3.21967C19.5484 2.92678 19.0735 2.92678 18.7806 3.21967L11.0954 10.9049L10.8864 10.6959C10.3024 10.1119 10.1354 9.22994 10.4654 8.47283C11.0418 7.15037 10.7501 5.60984 9.72999 4.58974L8.26066 3.12041C8.20093 3.06066 8.15492 3.01464 8.11183 2.97505Z"
                                fill="#1A1A1B"
                              />
                              <path
                                d="M16.5094 21.6401C13.4859 20.9682 10.7455 19.5743 8.47578 17.6459L13.1561 12.9656L13.2832 13.0927C13.8672 13.6767 14.7492 13.8437 15.5063 13.5137C16.8287 12.9372 18.3693 13.229 19.3894 14.2491L20.8586 15.7184C20.9184 15.7781 20.9644 15.8241 21.004 15.8673C21.9708 16.9193 21.9708 18.5365 21.004 19.5886C20.9644 19.6317 20.9184 19.6777 20.8586 19.7375L19.9612 20.6349C19.0581 21.538 17.7562 21.9171 16.5094 21.6401Z"
                                fill="#1A1A1B"
                              />
                            </svg>
                          ) : (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3.3125 19.75L19.3124 3.75"
                                stroke="white"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                              />
                              <path
                                d="M5.15541 3.82566C5.63363 3.38624 6.3687 3.38624 6.84692 3.82566C6.86343 3.84083 6.88507 3.86223 6.96114 3.9383L8.41933 5.39649C9.00333 5.98049 9.17036 6.86244 8.84034 7.61955C8.26388 8.94201 8.55563 10.4825 9.57573 11.5026L10.5044 12.4313C10.7973 12.7242 11.2722 12.7242 11.5651 12.4313C11.858 12.1384 11.858 11.6635 11.5651 11.3707L10.6364 10.442C10.0524 9.85798 9.88536 8.97603 10.2154 8.21892C10.7918 6.89646 10.5001 5.35593 9.47999 4.33583L8.01066 2.8665C7.95093 2.80675 7.90492 2.76074 7.86183 2.72114C6.80974 1.75441 5.19259 1.75441 4.1405 2.72114C4.09741 2.76073 4.05142 2.80674 3.99169 2.86649L3.09419 3.76398C2.19108 4.66709 1.81196 5.96901 2.08902 7.21579C2.84746 10.6287 4.52596 13.681 6.85464 16.1028C7.1375 16.3969 7.60514 16.3913 7.8937 16.1027C8.19079 15.8056 8.18434 15.3234 7.89419 15.0196C5.77434 12.7995 4.24624 10.0086 3.5533 6.8904C3.3875 6.14425 3.61438 5.36511 4.15485 4.82464L5.0412 3.9383C5.11726 3.86223 5.1389 3.84083 5.15541 3.82566Z"
                                fill="white"
                              />
                              <path
                                d="M10.0998 16.9651C9.79087 16.7365 9.35913 16.7586 9.08735 17.0304C8.77211 17.3456 8.7974 17.8653 9.15481 18.1318C11.2286 19.678 13.6376 20.8035 16.2594 21.3862C17.5062 21.6632 18.8081 21.2841 19.7112 20.381L20.6086 19.4836C20.6684 19.4238 20.7144 19.3778 20.754 19.3347C21.7208 18.2826 21.7208 16.6654 20.754 15.6133C20.7144 15.5702 20.6684 15.5242 20.6086 15.4645L19.1394 13.9952C18.1193 12.9751 16.5787 12.6833 15.2563 13.2598C14.7733 13.4703 14.2396 13.4786 13.7648 13.3054C13.3925 13.1696 12.9462 13.1715 12.6659 13.4518C12.3571 13.7606 12.3677 14.2736 12.7494 14.4857C13.6893 15.0078 14.8371 15.0788 15.8556 14.6348C16.6127 14.3048 17.4947 14.4718 18.0787 15.0559L19.5369 16.514C19.6129 16.5901 19.6343 16.6117 19.6495 16.6283C20.0889 17.1065 20.0889 17.8415 19.6495 18.3198C19.6343 18.3363 19.6129 18.3579 19.5369 18.434L18.6505 19.3203C18.1101 19.8608 17.3309 20.0877 16.5848 19.9219C14.1942 19.3906 11.9959 18.3685 10.0998 16.9651Z"
                                fill="white"
                              />
                            </svg>
                          )}
                          &nbsp;&nbsp;Cancel Call
                        </>
                      )}
                      {status &&
                        status.indexOf(":") > 0 &&
                        (isMaxCallIconHover ? (
                          <>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="25"
                              height="24"
                              viewBox="0 0 25 24"
                              fill="none"
                            >
                              <g clipPath="url(#clip0_21550_99648)">
                                <path
                                  d="M21.5924 17.4042C23.0199 17.3439 24.1634 16.2004 24.2237 14.7728C24.2262 14.7144 24.2262 14.6493 24.2262 14.5648L24.2262 13.2956C24.2262 12.0184 23.5737 10.8297 22.4962 10.144C16.3826 6.25361 8.56977 6.25361 2.45624 10.144C1.37872 10.8297 0.726205 12.0184 0.726203 13.2956L0.726203 14.5647C0.726192 14.6493 0.726186 14.7144 0.728659 14.7728C0.789015 16.2004 1.93252 17.3439 3.36004 17.4042C3.41853 17.4067 3.48361 17.4067 3.56815 17.4067L5.646 17.4067C7.08864 17.4067 8.38426 16.5237 8.91177 15.1809C9.21376 14.4122 9.9555 13.9067 10.7814 13.9067L14.171 13.9067C14.9969 13.9067 15.7386 14.4122 16.0406 15.1809C16.5681 16.5237 17.8638 17.4067 19.3064 17.4067L21.3844 17.4067C21.4688 17.4067 21.5339 17.4067 21.5924 17.4042Z"
                                  fill="#1A1A1B"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_21550_99648">
                                  <rect
                                    width="24"
                                    height="24"
                                    fill="white"
                                    transform="translate(0.5)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                            &nbsp;&nbsp;End Call
                          </>
                        ) : (
                          <>
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M21.108 17.6244C22.5355 17.5641 23.679 16.4206 23.7394 14.9931C23.7418 14.9346 23.7418 14.8695 23.7418 14.7851L23.7418 13.5158C23.7418 12.2386 23.0893 11.0499 22.0118 10.3643C15.8983 6.47383 8.08539 6.47383 1.97187 10.3643C0.894346 11.0499 0.241831 12.2386 0.24183 13.5158V14.7849C0.241819 14.8695 0.241812 14.9346 0.244286 14.9931C0.304641 16.4206 1.44814 17.5641 2.87566 17.6244C2.93415 17.6269 2.99924 17.6269 3.08378 17.6269L5.16163 17.6269C6.60427 17.6269 7.89989 16.7439 8.42739 15.4011C8.72939 14.6324 9.47112 14.1269 10.297 14.1269L13.6866 14.1269C14.5125 14.1269 15.2543 14.6324 15.5563 15.4011C16.0838 16.7439 17.3794 17.6269 18.822 17.6269L20.9 17.6269C20.9845 17.6269 21.0495 17.6269 21.108 17.6244ZM22.2407 14.9297C22.2133 15.5786 21.6935 16.0983 21.0446 16.1258C21.0222 16.1267 20.9918 16.1269 20.8842 16.1269L18.822 16.1269C17.9961 16.1269 17.2544 15.6214 16.9524 14.8527C16.4249 13.5099 15.1293 12.6269 13.6866 12.6269L10.297 12.6269C8.85439 12.6269 7.55877 13.5099 7.03127 14.8527C6.72927 15.6214 5.98753 16.1269 5.16163 16.1269L3.09943 16.1269C2.99186 16.1269 2.96143 16.1267 2.93903 16.1258C2.29015 16.0983 1.77038 15.5786 1.74295 14.9297C1.742 14.9073 1.74183 14.8769 1.74183 14.7693V13.5158C1.74183 12.7515 2.13233 12.0401 2.77718 11.6297C8.39936 8.052 15.5843 8.052 21.2065 11.6297C21.8513 12.0401 22.2418 12.7515 22.2418 13.5158L22.2418 14.7693C22.2418 14.8769 22.2417 14.9073 22.2407 14.9297Z"
                                fill="white"
                              />
                            </svg>
                            &nbsp;&nbsp;End Call
                          </>
                        ))}
                    </button> */}
                  <button
                    className="mt-8 px-6 py-2 bg-red-500 text-white rounded-md hover:bg-white hover:text-[#1A1A1B] hover:border hover:border-red-500 transition flex items-center gap-2"
                    onClick={() => {
                      setCallingModal(false);
                      setIsChat(true);
                      handleHangup();
                    }}
                    onMouseEnter={() => setIsMaxCallIconHover(true)}
                    onMouseLeave={() => setIsMaxCallIconHover(false)}
                  >
                    {["Calling", "Ringing"].includes(status) ? (
                      <>
                        {isMaxCallIconHover ? (
                          // Cancel icon on hover
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M8.11183 2.97505C7.05974 2.00832 5.44259 2.00832 4.3905 2.97505C4.34741 3.01464 4.30142 3.06065 4.24169 3.12039L3.34419 4.01788C2.44108 4.921 2.06196 6.22292 2.33902 7.4697C3.01964 10.5325 4.44123 13.3048 6.40871 15.5916L2.7807 19.2197C2.48781 19.5126 2.48781 19.9874 2.78071 20.2803C3.0736 20.5732 3.54847 20.5732 3.84137 20.2803L19.8413 4.28033C20.1342 3.98743 20.1342 3.51256 19.8413 3.21967C19.5484 2.92678 19.0735 2.92678 18.7806 3.21967L11.0954 10.9049L10.8864 10.6959C10.3024 10.1119 10.1354 9.22994 10.4654 8.47283C11.0418 7.15037 10.7501 5.60984 9.72999 4.58974L8.26066 3.12041C8.20093 3.06066 8.15492 3.01464 8.11183 2.97505Z"
                              fill="#1A1A1B"
                            />
                            <path
                              d="M16.5094 21.6401C13.4859 20.9682 10.7455 19.5743 8.47578 17.6459L13.1561 12.9656L13.2832 13.0927C13.8672 13.6767 14.7492 13.8437 15.5063 13.5137C16.8287 12.9372 18.3693 13.229 19.3894 14.2491L20.8586 15.7184C20.9184 15.7781 20.9644 15.8241 21.004 15.8673C21.9708 16.9193 21.9708 18.5365 21.004 19.5886C20.9644 19.6317 20.9184 19.6777 20.8586 19.7375L19.9612 20.6349C19.0581 21.538 17.7562 21.9171 16.5094 21.6401Z"
                              fill="#1A1A1B"
                            />
                          </svg>
                        ) : (
                          // Cross phone icon
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.3125 19.75L19.3124 3.75"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                            />
                            <path
                              d="M5.15541 3.82566C5.63363 3.38624 6.3687 3.38624 6.84692 3.82566C6.86343 3.84083 6.88507 3.86223 6.96114 3.9383L8.41933 5.39649C9.00333 5.98049 9.17036 6.86244 8.84034 7.61955C8.26388 8.94201 8.55563 10.4825 9.57573 11.5026L10.5044 12.4313C10.7973 12.7242 11.2722 12.7242 11.5651 12.4313C11.858 12.1384 11.858 11.6635 11.5651 11.3707L10.6364 10.442C10.0524 9.85798 9.88536 8.97603 10.2154 8.21892C10.7918 6.89646 10.5001 5.35593 9.47999 4.33583L8.01066 2.8665C7.95093 2.80675 7.90492 2.76074 7.86183 2.72114C6.80974 1.75441 5.19259 1.75441 4.1405 2.72114C4.09741 2.76073 4.05142 2.80674 3.99169 2.86649L3.09419 3.76398C2.19108 4.66709 1.81196 5.96901 2.08902 7.21579C2.84746 10.6287 4.52596 13.681 6.85464 16.1028C7.1375 16.3969 7.60514 16.3913 7.8937 16.1027C8.19079 15.8056 8.18434 15.3234 7.89419 15.0196C5.77434 12.7995 4.24624 10.0086 3.5533 6.8904C3.3875 6.14425 3.61438 5.36511 4.15485 4.82464L5.0412 3.9383C5.11726 3.86223 5.1389 3.84083 5.15541 3.82566Z"
                              fill="white"
                            />
                            <path
                              d="M10.0998 16.9651C9.79087 16.7365 9.35913 16.7586 9.08735 17.0304C8.77211 17.3456 8.7974 17.8653 9.15481 18.1318C11.2286 19.678 13.6376 20.8035 16.2594 21.3862C17.5062 21.6632 18.8081 21.2841 19.7112 20.381L20.6086 19.4836C20.6684 19.4238 20.7144 19.3778 20.754 19.3347C21.7208 18.2826 21.7208 16.6654 20.754 15.6133C20.7144 15.5702 20.6684 15.5242 20.6086 15.4645L19.1394 13.9952C18.1193 12.9751 16.5787 12.6833 15.2563 13.2598C14.7733 13.4703 14.2396 13.4786 13.7648 13.3054C13.3925 13.1696 12.9462 13.1715 12.6659 13.4518C12.3571 13.7606 12.3677 14.2736 12.7494 14.4857C13.6893 15.0078 14.8371 15.0788 15.8556 14.6348C16.6127 14.3048 17.4947 14.4718 18.0787 15.0559L19.5369 16.514C19.6129 16.5901 19.6343 16.6117 19.6495 16.6283C20.0889 17.1065 20.0889 17.8415 19.6495 18.3198C19.6343 18.3363 19.6129 18.3579 19.5369 18.434L18.6505 19.3203C18.1101 19.8608 17.3309 20.0877 16.5848 19.9219C14.1942 19.3906 11.9959 18.3685 10.0998 16.9651Z"
                              fill="white"
                            />
                          </svg>
                        )}
                        Cancel Call
                      </>
                    ) : status?.includes(":") ? (
                      <>
                        {isMaxCallIconHover ? (
                          // Filled End Call icon on hover
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                          >
                            <g clipPath="url(#clip0_21550_99648)">
                              <path
                                d="M21.5924 17.4042C23.0199 17.3439 24.1634 16.2004 24.2237 14.7728C24.2262 14.7144 24.2262 14.6493 24.2262 14.5648L24.2262 13.2956C24.2262 12.0184 23.5737 10.8297 22.4962 10.144C16.3826 6.25361 8.56977 6.25361 2.45624 10.144C1.37872 10.8297 0.726205 12.0184 0.726203 13.2956L0.726203 14.5647C0.726192 14.6493 0.726186 14.7144 0.728659 14.7728C0.789015 16.2004 1.93252 17.3439 3.36004 17.4042C3.41853 17.4067 3.48361 17.4067 3.56815 17.4067L5.646 17.4067C7.08864 17.4067 8.38426 16.5237 8.91177 15.1809C9.21376 14.4122 9.9555 13.9067 10.7814 13.9067L14.171 13.9067C14.9969 13.9067 15.7386 14.4122 16.0406 15.1809C16.5681 16.5237 17.8638 17.4067 19.3064 17.4067L21.3844 17.4067C21.4688 17.4067 21.5339 17.4067 21.5924 17.4042Z"
                                fill="#1A1A1B"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_21550_99648">
                                <rect
                                  width="24"
                                  height="24"
                                  fill="white"
                                  transform="translate(0.5)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        ) : (
                          // Outline End Call icon
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M21.108 17.6244C22.5355 17.5641 23.679 16.4206 23.7394 14.9931C23.7418 14.9346 23.7418 14.8695 23.7418 14.7851L23.7418 13.5158C23.7418 12.2386 23.0893 11.0499 22.0118 10.3643C15.8983 6.47383 8.08539 6.47383 1.97187 10.3643C0.894346 11.0499 0.241831 12.2386 0.24183 13.5158V14.7849C0.241819 14.8695 0.241812 14.9346 0.244286 14.9931C0.304641 16.4206 1.44814 17.5641 2.87566 17.6244C2.93415 17.6269 2.99924 17.6269 3.08378 17.6269L5.16163 17.6269C6.60427 17.6269 7.89989 16.7439 8.42739 15.4011C8.72939 14.6324 9.47112 14.1269 10.297 14.1269L13.6866 14.1269C14.5125 14.1269 15.2543 14.6324 15.5563 15.4011C16.0838 16.7439 17.3794 17.6269 18.822 17.6269L20.9 17.6269C20.9845 17.6269 21.0495 17.6269 21.108 17.6244ZM22.2407 14.9297C22.2133 15.5786 21.6935 16.0983 21.0446 16.1258C21.0222 16.1267 20.9918 16.1269 20.8842 16.1269L18.822 16.1269C17.9961 16.1269 17.2544 15.6214 16.9524 14.8527C16.4249 13.5099 15.1293 12.6269 13.6866 12.6269L10.297 12.6269C8.85439 12.6269 7.55877 13.5099 7.03127 14.8527C6.72927 15.6214 5.98753 16.1269 5.16163 16.1269L3.09943 16.1269C2.99186 16.1269 2.96143 16.1267 2.93903 16.1258C2.29015 16.0983 1.77038 15.5786 1.74295 14.9297C1.742 14.9073 1.74183 14.8769 1.74183 14.7693V13.5158C1.74183 12.7515 2.13233 12.0401 2.77718 11.6297C8.39936 8.052 15.5843 8.052 21.2065 11.6297C21.8513 12.0401 22.2418 12.7515 22.2418 13.5158L22.2418 14.7693C22.2418 14.8769 22.2417 14.9073 22.2407 14.9297Z"
                              fill="white"
                            />
                          </svg>
                        )}
                        End Call
                      </>
                    ) : (
                      // Default fallback button text (optional)
                      <>End Call</>
                    )}
                  </button>
                </>
              )}
            </div>
            {/* <div  style={{ position:'fixed',left:'calc(100vh - )' }}> */}

            {/* </div> */}
          </div>
        </div>
      ) : (
        <MiniCallingScreen
          onChatClickMinView={onChatClickMinView}
          pName={pName}
          callErrorMsg={callErrorMsg}
          status={status}
          label={label}
          isMiniScreen={isMiniScreen}
          setIsMiniScreen={setIsMiniScreen}
          isChat={isChat}
          setIsChat={setIsChat}
          handleHangup={handleHangup}
          mute={mute}
          muteCall={muteCall}
          unMuteCall={unMuteCall}
          maximizeCall={maximizeCall}
        />
      )}
    </>
  );
};

export default CallingScreen;
